var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/animations.scss": "bc44",
	"./assets/colors.scss": "62d7",
	"./assets/community.png": "7ee2",
	"./assets/conference_call.svg": "1bd5",
	"./assets/desk.svg": "0e01",
	"./assets/desktop.css": "ebf2",
	"./assets/edgeryders_1.jpg": "b88a",
	"./assets/edgeryders_2.jpg": "b0ff",
	"./assets/edgeryders_group.jpg": "1502",
	"./assets/ethnography.png": "c744",
	"./assets/graphryder.png": "09b4",
	"./assets/img/press/dazed.png": "e532",
	"./assets/img/press/di.png": "8f5d",
	"./assets/img/press/guardian.jpg": "cb37",
	"./assets/img/press/huffpost.jpg": "a2d1",
	"./assets/img/press/ilsole24ore.png": "703e",
	"./assets/img/press/krautreporter.png": "9c2e",
	"./assets/img/press/mutinerie.png": "da96",
	"./assets/img/press/nation.png": "e536",
	"./assets/img/press/nesta.png": "ceff",
	"./assets/img/press/newyorker.jpg": "ec78",
	"./assets/img/press/opengov.png": "4a73",
	"./assets/img/press/republica.png": "4bd5",
	"./assets/img/press/wired.png": "6a6f",
	"./assets/index.scss": "139c",
	"./assets/mailchimp-gdpr.svg": "41fe",
	"./assets/main.css": "845f",
	"./assets/mixins.scss": "ebdc",
	"./assets/mooc.png": "4139",
	"./assets/ngi_logo.png": "e9b1",
	"./assets/oci.svg": "ada1",
	"./assets/oci_contributor.svg": "2655",
	"./assets/oci_lab.png": "6404",
	"./assets/oci_leader.svg": "fa86",
	"./assets/oci_owner.svg": "9148",
	"./assets/questions.svg": "e034",
	"./assets/robin.mp4": "a700",
	"./assets/typography.scss": "db8c",
	"./assets/world.svg": "32d1",
	"./components/Academy": "3eb6",
	"./components/Academy.vue": "3eb6",
	"./components/Card": "ae8d",
	"./components/Card.vue": "ae8d",
	"./components/Carousel": "3693",
	"./components/Carousel.vue": "3693",
	"./components/Course": "5cfb",
	"./components/Course.vue": "5cfb",
	"./components/Courses": "61e5",
	"./components/Courses.vue": "61e5",
	"./components/Current": "d836",
	"./components/Current.vue": "d836",
	"./components/Custom": "5476",
	"./components/Custom.vue": "5476",
	"./components/Development": "fbee",
	"./components/Development.vue": "fbee",
	"./components/Discussion": "d58d",
	"./components/Discussion.vue": "d58d",
	"./components/Edgeryders": "41b2",
	"./components/Edgeryders.vue": "41b2",
	"./components/Event": "59f4",
	"./components/Event.vue": "59f4",
	"./components/Events": "19b8",
	"./components/Events.vue": "19b8",
	"./components/FlipCard": "8355",
	"./components/FlipCard.vue": "8355",
	"./components/Form": "8477",
	"./components/Form.vue": "8477",
	"./components/Hero": "2514",
	"./components/Hero.vue": "2514",
	"./components/HowItWorks": "0d0b",
	"./components/HowItWorks.vue": "0d0b",
	"./components/Jobs": "8fcb",
	"./components/Jobs.vue": "8fcb",
	"./components/Learn": "5373",
	"./components/Learn.vue": "5373",
	"./components/Mission": "1809",
	"./components/Mission.vue": "1809",
	"./components/NGI": "5078",
	"./components/NGI.vue": "5078",
	"./components/Navigation": "f4dd",
	"./components/Navigation.vue": "f4dd",
	"./components/Partners": "f5e5",
	"./components/Partners.vue": "f5e5",
	"./components/People": "ab59",
	"./components/People.vue": "ab59",
	"./components/Profile": "66aa",
	"./components/Profile.vue": "66aa",
	"./components/Row": "797f",
	"./components/Row.vue": "797f",
	"./components/Share": "17a4",
	"./components/Share.vue": "17a4",
	"./components/Slider": "89fb",
	"./components/Slider.vue": "89fb",
	"./components/Stack": "cf0e",
	"./components/Stack.vue": "cf0e",
	"./components/Stories": "1a8d",
	"./components/Stories.vue": "1a8d",
	"./components/Terms": "d5d2",
	"./components/Terms.vue": "d5d2",
	"./components/Topics": "ee61",
	"./components/Topics.vue": "ee61",
	"./components/Users": "dbef",
	"./components/Users.vue": "dbef",
	"./components/form/Body": "47f6",
	"./components/form/Body.vue": "47f6",
	"./components/form/Error": "ee33",
	"./components/form/Error.vue": "ee33",
	"./components/form/Field": "4250",
	"./components/form/Field.vue": "4250",
	"./components/form/Fields": "51f6",
	"./components/form/Fields.vue": "51f6",
	"./components/form/Navigation": "4f00",
	"./components/form/Navigation.vue": "4f00",
	"./components/form/Progress": "a05a",
	"./components/form/Progress.vue": "a05a",
	"./components/form/Title": "6c1b",
	"./components/form/Title.vue": "6c1b",
	"./components/views/CalComp": "c468",
	"./components/views/CalComp.vue": "c468",
	"./components/views/Calendar": "4bfe",
	"./components/views/Calendar.vue": "4bfe",
	"./components/views/Carousel": "837a",
	"./components/views/Carousel.vue": "837a",
	"./components/views/Filters": "3286",
	"./components/views/Filters.vue": "3286",
	"./components/views/Hero_Category": "5424",
	"./components/views/Hero_Category.vue": "5424",
	"./components/views/Hero_Custom": "9bcd",
	"./components/views/Hero_Custom.vue": "9bcd",
	"./components/views/Search": "214e",
	"./components/views/Search.vue": "214e",
	"./components/views/Subscribe": "1ee8",
	"./components/views/Subscribe.vue": "1ee8",
	"./components/views/Timeline": "bbc1",
	"./components/views/Timeline.vue": "bbc1",
	"./components/views/Video": "a904",
	"./components/views/Video.vue": "a904",
	"./data/config": "27be",
	"./data/config.json": "27be",
	"./data/covid19": "9fb0",
	"./data/covid19.json": "9fb0",
	"./helpers/discourse": "1574",
	"./helpers/discourse.js": "1574",
	"./main": "56d7",
	"./main.js": "56d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";